import { ReactElement } from 'react';
import { Empty, Select, Skeleton, Tag } from 'antd';
import { ChevronDownOutlined } from 'assets/icons/icons';
import { useVendorListings } from 'app/utils/api/queries';
import { ListingStatus, ListingType } from 'app/types';
import userSlice from 'app/store/user/user.slice';
import STORAGE_CONSTANTS from 'app/constants/storage';
import Storage from 'app/utils/storage/local';
import listingsSlice from 'app/store/listings/listings.slice';
import './listing_select.scss';

const ListingSelect = (): ReactElement => {
    const user = userSlice((state) => state.user);
    const { data, isLoading, isError } = useVendorListings();
    const { setCurrentListing, currentListingSelection } = listingsSlice();

    return (
        <div className='listing-select navbar-select__item'>
            {isLoading ? (
                <Skeleton paragraph={{ rows: 1, width: '100%' }} title={false} active loading />
            ) : (
                <Select
                    style={{ width: '100%' }}
                    aria-label='Select listing'
                    status={isError ? 'error' : ''}
                    popupClassName='navbar-select__selector'
                    value={currentListingSelection}
                    options={data
                        ?.slice()
                        ?.sort((a, b) => {
                            const isAActive =
                                a.status !== ListingStatus.SUSPENDED &&
                                a.status !== ListingStatus.RETIRED;
                            const isBActive =
                                b.status !== ListingStatus.SUSPENDED &&
                                b.status !== ListingStatus.RETIRED;

                            // eslint-disable-next-line no-nested-ternary
                            return isAActive === isBActive ? 0 : isAActive ? -1 : 1;
                        })
                        .map((listing: ListingType) => {
                            const isListingDisabled =
                                listing.status === ListingStatus.SUSPENDED ||
                                listing.status === ListingStatus.RETIRED;
                            return {
                                value: listing.pk,
                                label: (
                                    <span>
                                        {listing.title}{' '}
                                        {isListingDisabled ? (
                                            <Tag style={{ marginInlineStart: 5 }}>Disabled</Tag>
                                        ) : null}
                                    </span>
                                ),
                                disabled: isListingDisabled,
                                className: isListingDisabled ? 'ant-disabled-option' : '',
                            };
                        })}
                    notFoundContent={
                        <Empty
                            image={Empty.PRESENTED_IMAGE_DEFAULT}
                            description='No listings found'
                        />
                    }
                    onChange={(pk: number) => {
                        setCurrentListing(pk);
                        Storage.set(
                            `${STORAGE_CONSTANTS.currentListing}.${user?.email}`,
                            pk.toString()
                        );
                    }}
                    suffixIcon={<ChevronDownOutlined />}
                />
            )}
        </div>
    );
};

export default ListingSelect;
